<template>
  <v-expansion-panels
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-expansion-panel :class="panelClass">
      <v-expansion-panel-header
        v-if="!hideHeader"
        v-bind="headerProps"
        :class="headerClass"
      >
        <slot name="header">
          {{ title }}
        </slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content :class="contentClass">
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
// Transparent single-panel wrapper. Group props (accordion, flat, v-model,
// disabled, class, ...) flow through $attrs/$listeners to v-expansion-panels.
// Header and content markup come in via slots, so call-site scoped styles on
// that markup keep working; only the panel/header/content elements rendered
// here detach from the call site's scope (target them with ::v-deep).
// Vuetify 3 cutover: remap header -> v-expansion-panel-title and
// content -> v-expansion-panel-text in this one file.
export default {
  name: "EkitabuExpansionPanel",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    panelClass: {
      type: [String, Array, Object],
      default: "",
    },
    headerClass: {
      type: [String, Array, Object],
      default: "",
    },
    contentClass: {
      type: [String, Array, Object],
      default: "",
    },
    headerProps: {
      type: Object,
      default: () => ({}),
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
